import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchPurchaseOrders = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.PURCHASE_ORDER.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchPurchaseOrder = (payload) => {
  return axiosInstance.get(EndPoints.PURCHASE_ORDER.LIST_BY_ID + `/${payload}`);
}

export const createPurchaseOrder = (payload) => {
  return axiosInstance.post(EndPoints.PURCHASE_ORDER.CREATE, payload)
}

export const updatePurchaseOrder = (payload) => {
  return axiosInstance.put(EndPoints.PURCHASE_ORDER.UPDATE, payload)
}

export const approvePurchaseOrder = (payload) => {
  return axiosInstance.put(EndPoints.PURCHASE_ORDER.APPROVE_UPDATE, payload)
}

export const receivePurchaseOrder = (payload) => {
  const url = `${EndPoints.PURCHASE_ORDER.RECEIVE_UPDATE}/?po_id=${payload.po_id}&received_by=${payload.received_by}`;
  return axiosInstance.put(url);
};

export const deletePurchaseOrder = (payload) => {
  const url = EndPoints.PURCHASE_ORDER.DELETE + `/${payload}`
  return axiosInstance.delete(url)
}

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.PURCHASE_ORDER.DOWNLOAD_CSV, {
    responseType: 'blob'
  });
}
